import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { ProjectCard } from '../../../../components/ProjectCard';
import { Section } from '../../../../components/Section';
import { IHouseView } from '../../../../types/builder';
import { ScrollableSliderContainer } from '../../../ScrollableSliderContainer';
import { SLIDER_CONFIG } from './constants';

export interface IHousesSliderContainerProps {
  houses: IHouseView[];
  onHouseClick(house: IHouseView): void;
}

export const HousesSliderContainer: React.FC<IHousesSliderContainerProps> = ({ houses, onHouseClick }) => {
  const deviceType = useDeviceType();

  const renderSlide = (house: IHouseView) => <ProjectCard {...house} onClick={() => onHouseClick(house)} />;

  return (
    <Section fullWidth>
      <ScrollableSliderContainer slides={houses} renderSlide={renderSlide} {...SLIDER_CONFIG[deviceType]} />
    </Section>
  );
};
